export enum RequestReturnNoteType {
	General = 1,
	Private = 2,
}
